var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6526 48.6526C43.2696 54.0354 36.1126 57 28.5 57C20.8874 57 13.7304 54.0354 8.34739 48.6526C2.96459 43.2696 0 36.1126 0 28.5C0 20.8874 2.96459 13.7304 8.34739 8.34739C13.7304 2.96459 20.8874 0 28.5 0C36.1126 0 43.2696 2.96459 48.6526 8.34739C54.0354 13.7304 57 20.8874 57 28.5C57 36.1126 54.0354 43.2696 48.6526 48.6526ZM28.5 3.52578C14.7292 3.52578 3.52577 14.7292 3.52577 28.5C3.52577 42.2708 14.7292 53.4742 28.5 53.4742C42.2708 53.4742 53.4742 42.2708 53.4742 28.5C53.4742 14.7292 42.2708 3.52578 28.5 3.52578Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2795 17.4438L40.4217 28.5L21.2795 39.5563V17.4438Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.f7611df8265a8160eddf7f98c641ff50.svg";
export { ForwardRef as ReactComponent };